import { render, staticRenderFns } from "./page.vue?vue&type=template&id=4b39ac20&"
import script from "./page.ts?vue&type=script&lang=js&"
export * from "./page.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports